import React, { useEffect, useState, useContext } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { Modal, InputGroup, Form } from "react-bootstrap";
// import action
import { getpairs, setBotStatus } from "../../actions/Bottrade";

// import lib
import { toFixed, toFixedDown } from "../../lib/roundOf";

import binance from "../../assets/images/binance.svg";
import kucoin from "../../assets/images/kucoin.png";
import bitmart from "../../assets/images/bitmart.png";
import { useNavigate } from "react-router-dom";
import ExchangeBalance from "./ExchangeBalance";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import isEmpty from "../../lib/isEmpty";
import SocketContext from "../Context/SocketContext";

let strategy = {
  dayFilter: "thirtyDays",
  handleDFilter: "thirtyDays",
  byExchange: "Binance",
  from: 0,
  handleFrom: 0,
  handleTo: 0,
  to: 0,
  confirmStatus: false,
  cancelStatus: false,
};
export default function TradePairs(props) {
  const socketContext = useContext(SocketContext);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // state
  const { params, pairsAll, updatePair, balancefetchAll } = props;
  const { bot, pair, exchange } = params;
  let botType = bot == "dca" ? "Genie" : "Grid";
  const [PairListData, setPairListData] = useState();
  const [PairList, setPairList] = useState();
  const [hideBal, setHideBal] = useState(false);
  const [searchby, setsearchby] = useState("USDT");
  const [searchbyinput, setsearchbyinput] = useState();
  const [sortby, Setsortby] = useState("asc");
  const [totalbalance, setTotalbalance] = useState({});
  const [errMsg, setErrMsg] = useState({});
  const [strategyFilter, setSFilter] = useState(strategy);
  const [show, setShow] = useState(false);

  // redux
  const botData = useSelector((state) => state.botStatus);
  // function
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const splitData = (value) => {
    let data = value.split("-");
    return data[0] + data[1];
  };
  let {
    dayFilter,
    handleDFilter,
    byExchange,
    confirmStatus,
    handleFrom,
    handleTo,
    from,
    to,
    cancelStatus,
  } = strategyFilter;

  const gotoTrade = async (pair) => {
    // if (botData?.pair != pair) {
    //   dispatch(setBotStatus({ status: false, crtBot: true, pair: pair }));
    // } else {
    dispatch(
      setBotStatus({
        status: false,
        crtBot: true,
        openStatus: true,
        pair: pair,
      })
    );
    // }
    console.log(pair, "---------pair");
    console.log(params.pair, "---------params.pair");
    if (pair != params.pair) {
      const url = `/trade/${pair}/${params.exchange}/${params.bot}`;
      updatePair({
        exchange: params.exchange,
        bot: params.bot,
        pair: pair,
      });

      navigate(url);
    }
    // window.location.href = url;
  };

  const OnclicksortBy = async (key) => {
    // alert(key + sortby);
    let sort = "";
    if (sortby == "asc") {
      sort = "desc";
    } else {
      sort = "asc";
    }
    let sortedPairlist = "";
    if (sort == "asc") {
      if (key == "change" || key == "markPrice") {
        sortedPairlist = PairList.sort(
          (a, b) => parseFloat(b[key]) - parseFloat(a[key]) // asc
        );
      } else if (key == "quantity") {
        sortedPairlist = PairList.sort(
          (a, b) =>
            parseFloat(b.Orders.quantity) - parseFloat(a.Orders.quantity) // desc
        );
      } else if (key == "profit") {
        sortedPairlist = PairList.sort(
          (a, b) => parseFloat(b.Orders.profit) - parseFloat(a.Orders.profit) // desc
        );
      }
    }

    if (sort == "desc") {
      if (key == "change" || key == "markPrice") {
        sortedPairlist = PairList.sort(
          (a, b) => parseFloat(a[key]) - parseFloat(b[key]) // desc
        );
      } else if (key == "quantity") {
        sortedPairlist = PairList.sort(
          (a, b) =>
            parseFloat(a.Orders.quantity) - parseFloat(b.Orders.quantity) // desc
        );
      } else if (key == "profit") {
        sortedPairlist = PairList.sort(
          (a, b) => parseFloat(a.Orders.profit) - parseFloat(b.Orders.profit) // desc
        );
      }
    }

    setPairList(sortedPairlist);
    Setsortby(sort);
  };

  const handleClick = async (bot) => {
    const url = "/trade/" + params.pair + "/" + params.exchange + "/" + bot;
    window.location.href = url;
  };

  const searchpair = (e) => {
    e.preventDefault();
    setsearchbyinput(e.target.value);
    var searcharr = [];
    if (PairListData && PairListData.length > 0) {
      for (var i = 0; i < PairListData.length; i++) {
        var temppair =
          PairListData[i].firstCurrencySymbol +
          "/" +
          PairListData[i].secondCurrencySymbol;
        if (temppair.indexOf(e.target.value.toUpperCase()) !== -1) {
          searcharr.push(PairListData[i]);
        }
        if (i == PairListData.length - 1) {
          setPairList(searcharr);
        }
      }
    }
  };

  useEffect(() => {
    let socketTicker = "socketTicker" + params.exchange;
    socketContext[socketTicker].on("marketPrice", (result) => {
      console.log(result,"heellll")
      setPairList((el) => {
        let pairList = [];
        if (el) {
          el.map((item) => {
            if (item._id == result.pairId) {
              
              pairList.push({
                ...item,
                // markPrice: toFixedDown(result.data.markPrice, 8),
                markPrice: result?.data?.markPrice,
                change: toFixedDown(result?.data?.change, 3),
              });
            } else {
              pairList.push(item);
            }
          });
        }
        return pairList;
      });
    });


    return () => {
      socketContext[socketTicker].off("marketPrice");
    };
    
  }, [pairsAll]);

  useEffect(() => {
    // if (params.bot == "dca") {
    //   pairsAll?.sort(
    //     (a, b) => parseFloat(b.dcaProfit) - parseFloat(a.dcaProfit) // desc
    //   );
    // } else {
    //   pairsAll?.sort(
    //     (a, b) => parseFloat(b.gridProfit) - parseFloat(a.gridProfit) // desc
    //   );
    // }

    console.log(pairsAll,"pairsAllpairsAll")

    setPairListData(pairsAll);
    setPairList(pairsAll);
  }, [pairsAll]);


  // useEffect(() => {
  //   let socketTicker = "socketTicker" + params.exchange;
  //   return () => {
  //     socketContext[socketTicker].off("marketPrice");
  //   };
  // }, []);

  // Spot History Table

  useEffect(() => {
    let totalLocked = 0,
      totalfree = 0;
    balancefetchAll &&
      balancefetchAll.length > 0 &&
      balancefetchAll.map((item, key) => {
        let pairData = PairListData?.find(
          (el) => el.tikerRoot.toString() == item.asset + "USDT"
        );
        let markPrice = parseFloat(
          item.asset != "USDT" ? pairData?.markPrice : 1
        );
        if (item?.locked > 0 && pairData?.markPrice) {
          totalLocked += parseFloat(item?.locked) * markPrice;
        }
        if (item?.free > 0 && pairData?.markPrice) {
          totalfree += parseFloat(item?.free) * markPrice;
        }
      });

    setTotalbalance({ totalLocked: totalLocked, totalfree: totalfree });
  }, [balancefetchAll, PairListData]);

  const handleChange = (e) => {
    setErrMsg({});
    const { name, value } = e.target;
    if (/[^0-9.]/.test(value)) {
      return;
    }
    let sFilter = strategyFilter;
    let hTo = name == "handleTo" ? value : sFilter.handleTo,
      hFrom = name == "handleFrom" ? value : sFilter.handleFrom;
    setSFilter({
      ...sFilter,
      ...{ [name]: value, confirmStatus: true, cancelStatus: false },
    });
    if (hTo > 0 && hFrom > 0 && hFrom >= hTo) {
      setErrMsg({
        to: "The Maximum value of the Current profit can't be lower than its minimum value.",
      });
    }
  };
  const handleFilter = () => {
    let sFilter = strategyFilter;
    let formValue = {
      ...sFilter,
      ...{
        dayFilter: sFilter.handleDFilter,
        from: sFilter.handleFrom,
        to: sFilter.handleTo,
        confirmStatus: false,
        cancelStatus: false,
      },
    };
    setSFilter(formValue);
    setShow(false);
  };
  const handleCFilter = (days) => {
    setSFilter({
      ...strategyFilter,
      ...{ handleDFilter: days, confirmStatus: true },
    });
  };
  const handleClear = () => {
    let sFilter = strategyFilter;
    let formValue = {
      ...sFilter,
      ...{
        handleDFilter: "thirtyDays",
        handleFrom: 0,
        handleTo: 0,
        confirmStatus: true,
        cancelStatus: true,
      },
    };
    setSFilter(formValue);
  };
  return (
    <>
      <div className="coin_details zindex">
        <div className="card trade_card">
          <div className="card-header">
            <ul
              class="nav nav-tabs bottab bottab_fullwidth nav-fill"
              id="myTab"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="strategies-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#strategies-tab-pane"
                >
                  Strategies
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="balance-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#balance-tab-pane"
                >
                  Balance
                </button>
              </li>
            </ul>
          </div>
          <div className="card-body">
            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="strategies-tab-pane"
                role="tabpanel"
                aria-labelledby="strategies-tab"
                tabindex="0"
              >
                <ul
                  className="nav nav-tabs bottab mt-2"
                  id="myTab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      // onClick={() => searchbysymbol("USDT")}
                      className={
                        params.bot == "dca" ? "nav-link active" : "nav-link"
                      }
                      id="coin_one-tab"
                      type="button"
                      data-bs-toggle="tab"
                      data-bs-target="#coin_one"
                      role="tab"
                      aria-controls="coin_one"
                      aria-selected="true"
                      onClick={() => handleClick("dca")}
                    >
                      DCA
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      // onClick={() => searchbysymbol("BTC")}
                      className={`${params.bot == "grid" ? "nav-link active" : "nav-link"
                        }`}
                      id="coin_two-tab"
                      type="button"
                      data-bs-toggle="tab"
                      data-bs-target="#coin_two"
                      role="tab"
                      aria-controls="coin_two"
                      aria-selected="false"
                      onClick={() => handleClick("grid")}
                    >
                      GRID
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div className="strategy_filter">
                    <div className="search_inp_div">
                      <input
                        type="text"
                        placeholder="Search Pair"
                        className="form-control search_inp"
                        name="symbol"
                        value={searchbyinput}
                        onChange={searchpair}
                      />
                      <i className="bi bi-search"></i>
                    </div>
                    <button className="settings_button" onClick={handleShow}>
                      <i className="bi bi-sliders2"></i>
                    </button>
                  </div>
                  {/* id coin one */}
                  <div
                    className={
                      params.bot == "dca"
                        ? "tab-pane fade show active"
                        : "tab-pane fade show"
                    }
                    id="coin_one"
                    role="tabpanel"
                    aria-labelledby="coin_one-tab"
                  >
                    <div className="pair_table pair_table_chg">
                      <div className="pair_table_head">
                        <div onClick={() => OnclicksortBy("quantity")}>
                          {" "}
                          Pair
                        </div>
                        <div onClick={() => OnclicksortBy("markPrice")}>
                          Price
                        </div>
                        <div onClick={() => OnclicksortBy("profit")}>
                          24H
                        </div>
                        {/* <div>Profit</div> */}
                      </div>
                      <div className="pair_table_body">
                        <Scrollbars
                          style={{ height: "1125px", width: "100%" }}
                          renderTrackVertical={({ style, ...props }) => (
                            <div
                              className="track_vertical"
                              {...props}
                              style={{
                                ...style,
                                right: "0px",
                                bottom: "0px",
                                top: "0px",
                                borderRadius: "1px",
                                width: "2px",
                              }}
                            />
                          )}
                          renderThumbVertical={({ style, ...props }) => (
                            <div
                              className="thumb_vertical"
                              {...props}
                              style={{
                                ...style,
                                width: "2px",
                                borderRadius: "1px",
                                boxShadow: "none",
                              }}
                            />
                          )}
                        >
                          {PairList &&
                            PairList.length > 0 &&
                            PairList.map((item, key) => {
                              
                                return (
                                  <>
                                    <div
                                      onClick={() =>
                                        gotoTrade(
                                          item.firstCurrencySymbol +
                                          "-" +
                                          item.secondCurrencySymbol
                                        )
                                      }
                                      className={
                                        item.firstCurrencySymbol +
                                          "-" +
                                          item.secondCurrencySymbol ==
                                          params.pair
                                          ? "pair_table_bodyrow active"
                                          : "pair_table_bodyrow"
                                      }
                                    >
                                      <div className="pair_table_bodyrow_top">
                                        <div>
                                          <img src={binance} width="6%" />

                                          <h3>
                                            {item.firstCurrencySymbol}
                                            <span>
                                              / {item.secondCurrencySymbol}
                                            </span>
                                          </h3>
                                        </div>
                                      </div>
                                      <div className="direction_badge_wrap">
                                        <small >
                                          {item.markPrice}

                                        </small>
                                      </div>

                                      <div className="pair_table_bodyrow_bottom">
                                        <div className="pair_table_bodyrow_bottom_right">
                                          <div>
                                            <span>
                                              <small className="greenTxt">
                                                {toFixedDown(item.change, 2)}%
                                              </small>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              
                            })}
                        </Scrollbars>
                      </div>
                    </div>
                  </div>
                  {/* id coin two */}
                  <div
                    className={`${params.bot == "grid"
                        ? "tab-pane fade show active"
                        : "tab-pane fade show"
                      }`}
                    id="coin_two"
                    role="tabpanel"
                    aria-labelledby="coin_two-tab"
                  >
                    <div className="pair_table pair_table_chg">
                      <div className="pair_table_head">
                        <div onClick={() => OnclicksortBy("quantity")}>
                          {" "}
                          Pair
                        </div>
                        <div onClick={() => OnclicksortBy("markPrice")}>
                          Price
                        </div>
                        <div onClick={() => OnclicksortBy("profit")}>
                          24H
                        </div>
                        {/* <div>Profit</div> */}
                      </div>
                      <div className="pair_table_body">
                        <Scrollbars
                          style={{ height: "1125px" }}
                          renderTrackVertical={({ style, ...props }) => (
                            <div
                              className="track_vertical"
                              {...props}
                              style={{
                                ...style,
                                right: "2px",
                                bottom: "2px",
                                top: "2px",
                                borderRadius: "1px",
                                width: "2px",
                              }}
                            />
                          )}
                          renderThumbVertical={({ style, ...props }) => (
                            <div
                              className="thumb_vertical"
                              {...props}
                              style={{
                                ...style,
                                width: "2px",
                                borderRadius: "1px",
                                boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.16)",
                              }}
                            />
                          )}
                        >
                          {PairList &&
                            PairList.length > 0 &&
                            PairList.map((item, key) => {
                              
                                return (
                                  <>
                                    <div
                                      onClick={() =>
                                        gotoTrade(
                                          item.firstCurrencySymbol +
                                          "-" +
                                          item.secondCurrencySymbol
                                        )
                                      }
                                      className={
                                        item.firstCurrencySymbol +
                                          "-" +
                                          item.secondCurrencySymbol ==
                                          params.pair
                                          ? "pair_table_bodyrow active"
                                          : "pair_table_bodyrow"
                                      }
                                    >
                                      <div className="pair_table_bodyrow_top">
                                        <div>
                                          <img src={binance} width="6%" />

                                          <h3>
                                            {item.firstCurrencySymbol}
                                            <span>
                                              / {item.secondCurrencySymbol}
                                            </span>
                                          </h3>
                                        </div>
                                      </div>
                                      <div className="direction_badge_wrap">
                                        <small >
                                          {item.markPrice}
                                        </small>
                                      </div>

                                      <div className="pair_table_bodyrow_bottom">
                                        <div className="pair_table_bodyrow_bottom_right">
                                          <div>
                                            <span>
                                              <small className="greenTxt">
                                                {toFixedDown(item.change, 2)}%

                                              </small>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              
                            })}
                        </Scrollbars>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="balance-tab-pane"
                role="tabpanel"
                aria-labelledby="balance-tab"
                tabindex="0"
              >
                <div className="primary_table primary_table_normal zindex">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Currency</th>
                        <th>In trades</th>
                        <th>Available</th>
                      </tr>
                    </thead>
                    <tbody>
                      {balancefetchAll &&
                        balancefetchAll.length > 0 &&
                        balancefetchAll.map((item, key) => {
                          if (item?.free > 0) {
                            let pairData = PairListData?.find(
                              (el) =>
                                el.tikerRoot.toString() == item.asset + "USDT"
                            );
                            let markPrice =
                              item.asset != "USDT" ? pairData?.markPrice : 1;

                            return (
                              <tr>
                                <td>
                                  <div className="bal_pair">
                                    <img
                                      src={require("../../assets/images/btc.png")}
                                      alt="Icon"
                                      className="img-fluid"
                                      width="15px"
                                    />
                                    <span>{item.asset}</span>
                                  </div>
                                </td>
                                <td>
                                  <p className="mb-1">
                                    {item?.locked > 0 && item?.locked}
                                  </p>
                                  <p className="mb-0 usd_eqiv">
                                    {item?.locked > 0
                                      ? toFixedDown(
                                        item?.locked * markPrice,
                                        2
                                      ) + " USD"
                                      : " - "}
                                  </p>
                                </td>
                                <td>
                                  <p className="mb-1">{item?.free}</p>
                                  <p className="mb-0 usd_eqiv">
                                    {item?.free > 0
                                      ? toFixedDown(item?.free * markPrice, 2) +
                                      " USD"
                                      : " - "}
                                  </p>
                                </td>
                              </tr>
                            );
                          }
                        })}
                    </tbody>
                    <tfoot className="border_top">
                      <tr>
                        <td>Total</td>
                        <td>
                          {toFixedDown(totalbalance?.totalLocked, 2)}{" "}
                          <span className="greyTxt">USD</span>
                        </td>
                        <td>
                          {toFixedDown(totalbalance?.totalfree, 2)}{" "}
                          <span className="greyTxt">USD</span>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="primary_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{`${bot.toUpperCase()} strategies filter`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/*<div className="backtest_period">
            <p>Backtest period</p>
            <div className="backtest_periodbtn_grp">
              <button
                onClick={() => handleCFilter("thirtyDays")}
                className={handleDFilter == "thirtyDays" ? "selected" : ""}
              >
                30d
              </button>
              <button
                onClick={() => handleCFilter("sevenDays")}
                className={handleDFilter == "sevenDays" ? "selected" : ""}
              >
                7d
              </button>
              <button
                onClick={() => handleCFilter("threeDays")}
                className={handleDFilter == "threeDays" ? "selected" : ""}
              >
                3d
              </button> 
            </div>
          </div>*/}
          <div className="filter_panel">
            <div className="filter_panel_row">
              <label>By exchanges</label>
              <div className="filter_btn_grp">
                <button className="selected">Binance</button>
                {/* <button>Kucoin</button>
                <button>Bitmart</button> */}
              </div>
            </div>
            {/* <div className="filter_panel_row">
              <label>By availability</label>
              <div className="filter_btn_grp">
                <button className="selected">Available</button>
                <button>Other</button>
              </div>
            </div> */}
            {/* <div className="filter_panel_row">
              <label>Custom profit</label>
              <div className="filter_inp_grp createbot_box m-0">
                <div className="inputgrp_box">
                  <label className="grey">From, %</label>
                  <InputGroup className="w-100">
                    <Form.Control
                      aria-label="Username"
                      name="handleFrom"
                      aria-describedby="basic-addon1"
                      value={handleFrom}
                      onChange={(e) => handleChange(e)}
                    />
                  </InputGroup>
                </div>
                <div className="inputgrp_box">
                  <label className="grey">To, %</label>
                  <InputGroup
                    className={
                      errMsg && errMsg.to ? "w-100 red_border" : "w-100"
                    }
                  >
                    <Form.Control
                      aria-label="Username"
                      name="handleTo"
                      aria-describedby="basic-addon1"
                      value={handleTo}
                      onChange={(e) => handleChange(e)}
                    />
                  </InputGroup>
                  <span
                    className={
                      errMsg && errMsg.to
                        ? "text-danger error_msg"
                        : "text-danger"
                    }
                  >
                    {errMsg && errMsg.to}
                  </span>
                </div>
              </div>
            </div> */}
          </div>
          {!confirmStatus && !cancelStatus && (
            <div className="filter_panel_btn">
              <button class="continue border_btn" onClick={() => handleClear()}>
                Clear filter
              </button>
            </div>
          )}
          {cancelStatus && (
            <div className="filter_panel_btn">
              <button class="continue border_btn" onClick={() => handleClose()}>
                Cancel
              </button>
            </div>
          )}
          {confirmStatus && !cancelStatus && (
            <div className="filter_panel_btn">
              <button class="continue border_btn" onClick={() => handleClear()}>
                Clear filter
              </button>
              <button class="continue" onClick={() => handleFilter()}>
                Confirm
              </button>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
